import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getQueryParam, removeURLParameter } from '../helpers/url/urlHelpers';

/**
 * Payment providers send the user back to us with `?error=...` on the URL. Report it into the store
 * once and strip it from the address bar.
 *
 * The pages that need this used to do it inline in their render body, which both dispatched during
 * render and called `history.pushState` on *every* re-render. A few re-renders per second is enough
 * to trip the browser limit of 100 pushState calls per 10 seconds. Doing it in an effect keyed to
 * mount fires once, and `replaceState` avoids adding a history entry the user would have to click
 * back through.
 */
const usePaymentErrorFromQuery = (toAction: (error: string) => any): void => {
	const dispatch = useDispatch<any>();

	useEffect(() => {
		const paymentError = getQueryParam('error');

		if (paymentError === null) return;
		if (paymentError) dispatch(toAction(paymentError));

		window.history.replaceState({}, '', removeURLParameter('error'));
		// Runs on mount only: the parameter is removed from the URL as soon as it is consumed.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

export default usePaymentErrorFromQuery;
